import { useTranslation } from "react-i18next";
import { HoverPopover } from "@/components/ui";
import { FILTER_STATUS_DOT_CLASS } from "@/lib/statusDot";
import { cn } from "@/lib/utils";

export function AdminInactiveStatusDot() {
  const { t } = useTranslation("common");
  const label = t("inactive");

  return (
    <HoverPopover content={label} placement="above">
      <span
        className="inline-flex cursor-default items-center justify-center rounded-full p-0.5"
        aria-label={label}
        onClick={(event) => event.stopPropagation()}
      >
        <span
          className={cn(
            "h-2.5 w-2.5 rounded-full",
            FILTER_STATUS_DOT_CLASS.inactive,
          )}
          aria-hidden
        />
      </span>
    </HoverPopover>
  );
}
